module.exports = "https://trybtryb-legacy.web.app/img/list.72a8218b.svg";